import Scene from "./Scene";

export default Scene;
